import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const decodeToken = (token) => {
   try {
      return jwtDecode(token);
   } catch {
      return null;
   }
};

export const getMemberUID = (token = cookies.get('userToken') || '') => {
   if (token && token !== 'undefined') {
      try {
         const decoded = jwtDecode(token);
         return decoded.uid || '';
      } catch {
         return '';
      }
   }
   return '';
};

export const isLogin = (token = cookies.get('userToken') || '') => {
   const memberUID = getMemberUID(token);
   return memberUID !== '';
};

const getBaseURL = () => {
   const { protocol, hostname, port } = window.location;
   const isLocalhost = hostname === 'localhost' || hostname === '192.168.1.99';
   const portSuffix = isLocalhost ? `:${port}` : '';
   return `${protocol}//${hostname}${portSuffix}`;
};

const URL = getBaseURL();

export default { getMemberUID, isLogin, URL };
